export default {
  setState(context, payload) {
    context.commit('setState', payload);
  },
};
